import {all, call, put, takeEvery} from 'redux-saga/effects'
import {
  PersonRolesActionTypes,
  fetchError,
  fetchSuccess,
  createError,
  createSuccess,
  deleteError,
  deleteSuccess,
  updateSuccess, updateError
} from '@actions/person-role'
import personRoleApi from '@api/person-role'
import {ReduxAction} from "@actions/index";


function* handleFetch({payload}: ReduxAction) {
  try {
    const res = yield call(personRoleApi.getList, payload);
    yield put(fetchSuccess(res))
  }
  catch (err) {
    yield put(fetchError(err.stack!))
  }
}


function* handleDelete({payload}: ReduxAction) {
  try {
    yield call(personRoleApi.delete, payload);
    yield put(deleteSuccess(payload))
  }
  catch (err) {
    yield put(deleteError(err.stack!))
  }
}


function* handleCreate({payload}: ReduxAction) {
  try {
    const {data} = yield call(personRoleApi.create, payload);
    payload.onSuccessCallback && payload.onSuccessCallback(data);
    yield put(createSuccess(data))
  }
  catch (err) {
    yield put(createError(err.stack!));
    payload.onErrorCallback && payload.onErrorCallback(err);
  }
}


function* handleUpdate({payload}: ReduxAction) {
  try {
    const {data} = yield call(personRoleApi.update, payload);
    payload.onSuccessCallback && payload.onSuccessCallback();
    yield put(updateSuccess(data))
  }
  catch (err) {
    yield put(updateError(err.stack!));
    payload.onErrorCallback && payload.onErrorCallback(err);
  }
}


// We can also use `fork()` here to split our saga into multiple watchers.
function* personRolesSaga() {
  yield all([
    yield takeEvery(PersonRolesActionTypes.FETCH_REQUEST, handleFetch),
    yield takeEvery(PersonRolesActionTypes.DELETE_REQUEST, handleDelete),
    yield takeEvery(PersonRolesActionTypes.CREATE_REQUEST, handleCreate),
    yield takeEvery(PersonRolesActionTypes.UPDATE_REQUEST, handleUpdate),
  ])
}

export default personRolesSaga
